import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ProductTable2 = ({ products }) => {
  const location = useLocation();
  const [updatedProducts, setUpdatedProducts] = useState(products);

  // Actualiza el estado si 'products' cambia
  useEffect(() => {
    setUpdatedProducts(products);
  }, [products]);

  // Estilos para botones swal, solo una vez en useEffect para evitar multiples inserciones
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .swal-btn {
        font-size: 16px;
        font-weight: bold;
        padding: 10px 20px;
        border-radius: 5px;
        color: white;
        margin: 0 10px;
      }
      .swal-btn-confirm {
        background-color: #28a745;
        border: none;
      }
      .swal-btn-cancel {
        background-color: #dc3545;
        border: none;
      }
    `;
    document.head.appendChild(style);

    // Cleanup para remover estilos cuando el componente se desmonte
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const columns = [
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Fecha</div>,
      selector: row => row.fecha_hora_registro,
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.fecha_hora_registro}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Cliente</div>,
      selector: row => row.cliente?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.cliente}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Evento</div>,
      selector: row => row.descripcion?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.descripcion}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Tipo Dispositivo</div>,
      selector: row => row.tipo_dispositivo?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.tipo_dispositivo}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>IP</div>,
      selector: row => row.ip,
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.ip}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Dispositivo</div>,
      selector: row => row.dispositivo?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.dispositivo}
        </div>
      ),
      sortable: true,
    },
    
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Ocompra</div>,
      selector: row => row.ocompra,
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.ocompra}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Cantidad</div>,
      selector: row => Number(row.cantidad),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.cantidad}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Busqueda libre</div>,
      selector: row => row.busca_item?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.busca_item}
        </div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>SKU</div>,
      selector: row => row.sku?.toLowerCase(),
      cell: row => (
        <div style={{ width: '100%', textAlign: 'left', fontSize: '10px' }}>
          {row.sku}
        </div>
      ),
      sortable: true,
    },

   
  ];

  // Exportar a Excel
  const exportToExcel = () => {
    const exportData = updatedProducts.map(item => ({
      fecha: item.fecha_hora_registro,
      cliente: item.cliente,
      evento: item.descripcion,
      tipo_dispositivo: item.tipo_dispositivo,
      ip: item.ip,
      dispositivo: item.dispositivo,
      ocompra: item.ocompra,
      cantidad: item.cantidad,
      busca_item: item.busca_item,
      sku: item.sku,

    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const fechaActual = `${yyyy}-${mm}-${dd}`;

    saveAs(data, `estadisticas_${fechaActual}.xlsx`);
  };

  return (
    <div>
      <button
        onClick={exportToExcel}
        style={{
          marginBottom: '10px',
          padding: '8px 16px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold',
        }}
      >
        Exportar a Excel
      </button>

      <DataTable
        columns={columns}
        data={updatedProducts}
        customStyles={{
          rows: {
            style: { minHeight: '50px' },
          },
          headCells: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              paddingLeft: '8px',
              paddingRight: '8px',
              backgroundColor: '#f1f3f5',
            },
          },
          cells: {
            style: {
              fontSize: '11px',
              paddingLeft: '8px',
              paddingRight: '8px',
              whiteSpace: 'normal',
              overflow: 'visible',
            },
          },
        }}
      />
    </div>
  );
};

export default ProductTable2;
